


































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { Form } from 'element-ui'
import {
  getVipResignList,
  modifyResignCount,
  addVipResignRecord,
  getVipResignOptionList
} from '@/api/trade/trade'
import { exportJson2Excel } from '@/utils/excel'
import { formatJson, resetObjValue2NoneString, checkNoneString } from '@/utils/tool'
import moment from 'moment'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

@Component({
  name: 'TradeVip'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    udid: '',
    page: 1,
    pageCount: 20
  }
  udidParams = {
    id: 0,
    udid: '',
    newUdid: ''
  }
  moment = moment
  // component data
  goodsTypeList: any[] = []
  visible = false
  dateArrayCreate = ['', '']
  dateArrayExpire = ['', '']
  tableLoading = false
  tableData: any[] = []
  selectedData: any[] = []
  totalCount = 0
  formVisible = false
  rules: any = {
    udid: [{ required: true, message: '请填写UDID', trigger: 'blur' }],
    'vip_set': [{ required: true, message: '请选择VIP套餐', trigger: 'change' }]
  }
  private formParams = {
    udid: '',
    vip_set: ''
  }

  resignVisible: boolean = false

  private resignParams = {
    id: '',
    resign_count: 1
  }
  tableHeight: number = 500
  // lifecycle
  async created() {
    this.getTableData()
    this.getOptions()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res: any = await getVipResignList(this.params)
    this.tableData = res.data.dataList
    this.totalCount = res.data.pageInfo.totalCount
    this.tableLoading = false
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  async getOptions() {
    let res: any = await getVipResignOptionList()
    this.goodsTypeList = res.data.dataList
  }
  async handleExcel() {
    let p: any = { ...this.params }
    p.pageCount = 300
    let res: any = await getVipResignList(p)
    if (+res.status.code === 0) {
      setTimeout(() => {
        this['$message'].success('导出成功!')
      }, 200)
    } else {
      return this['$message'].error('导出失败!')
    }
    // const filterVal: string[] = [
    //   'id',
    //   'accountId',
    //   'certName',
    //   'applePwd',
    //   'iphoneCount',
    //   'itouchCount',
    //   'status',
    //   'info',
    //   'createDate',
    //   'creatorName'
    // ]
    // const theader: string[] = [
    //   'ID',
    //   '开发者账号',
    //   '证书',
    //   '专用密码',
    //   'iPhone可安装数量',
    //   'iPad可安装数量',
    //   '状态',
    //   '信息',
    //   '创建时间',
    //   '创建人'
    // ]
    // const list = res.data.dataList
    // const data = formatJson(filterVal, list)
    // exportJson2Excel(theader, data)
  }

  changeResignCount(row: any) {
    console.log(row.id)
    this.resignParams.id = row.id
    this.resignParams['resign_count'] = row['resign_count']
    this.resignVisible = true
  }

  handleCancel() {
    this.resignParams = {
      id: '',
      resign_count: 1
    }
    this.resignVisible = false
  }

  closeDialog() {
    this.handleCancel()
  }

  handleConfirm() {
    console.log(this.resignParams)
    const id = this.resignParams.id
    const count = this.resignParams['resign_count']
    if (typeof count !== 'number') {
      return this.$message.warning('请输入已重签次数')
    }
    modifyResignCount({ id, resign_count: count }).then((res: any) => {
      console.log(res)
      if (+res.status.code === 0) {
        this.$message.success('操作成功')
        this.resignVisible = false
        this.getTableData()
      } else {
        this.$message.error(res.status.message)
      }
    })
  }

  handleSearch() {
    if (this.tableLoading) { return false }
    let params: any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleAdd() {
    this.formVisible = true
  }
  closeForm() {
    (this.$refs['formParams'] as Form).resetFields()
    this.formVisible = false
  }

  cancelForm() {
    this.formVisible = false
  }
  confirmForm() {
    (this.$refs['formParams'] as Form).validate(async valid => {
      if (valid) {
        console.log(this.formParams)
        let res:any = await addVipResignRecord(this.formParams)
        console.log(res)
        if (~~res.status.code === 0) {
          this.$message.success('操作成功')
          this.formVisible = false
          await this.getTableData()
        }
      } else {
        this.$message.warning('请填写完表单再提交')
      }
    })
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArrayExpire = ['', '']
    this.dateArrayCreate = ['', '']
    this.params.page = 1
    this.getTableData()
  }
  handleSelectionChange(list: any[]) {
    console.log(list)
    this.selectedData = list
  }
  // close dialog, clear data
  handleFormClose() {
    this.udidParams = {
      id: 0,
      udid: '',
      newUdid: ''
    }
    this.visible = false
  }
}
